var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('PinnedBtnContainer',[_c('PinnedRuleBtn')],1),_c('img',{staticClass:"img",attrs:{"src":require("../assets/images/lalamove-error.png"),"alt":"unlucky"}}),_c('div',{staticClass:"text"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }